import CheckIcon from '@mui/icons-material/Check'

interface Props {
  children: boolean
}

export function BooleanValue(props: Props) {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{props.children ? <CheckIcon /> : null}</>
}
